import React from 'react';
import { ArrowRight } from 'lucide-react';
import { profileData } from '../../data/profileData';
import { getContentStats } from '../../utils/contentStats';
import { Button, Icon, LinkedInIcon, ResponsiveImage } from '../ui';
import './ProfileIntro.css';

interface ProfileIntroProps {
  scrollToSection: (sectionId: string) => void;
}

const ProfileIntro: React.FC<ProfileIntroProps> = ({ scrollToSection }) => {
  const { basicInfo } = profileData;
  const stats = getContentStats(profileData);
  const credibility = [
    { value: stats.articles, label: 'Articles published' },
    { value: stats.certifications, label: 'Certifications' },
    { value: stats.books, label: 'Books on my reading list' },
  ];

  return (
    <section className="hero" id="profile-intro" aria-labelledby="profile-intro-heading">
      <div className="hero__inner">
        <div className="hero__text">
          <p className="hero__role">{basicInfo.title}</p>
          <h1 id="profile-intro-heading" className="hero__name">
            {basicInfo.name}
          </h1>
          <p className="hero__positioning">{basicInfo.positioning}</p>

          <div className="hero__actions">
            <Button icon={<Icon icon={ArrowRight} size={18} />} onClick={() => scrollToSection('writing')}>
              Read my writing
            </Button>
            <Button href={basicInfo.linkedIn} variant="secondary" icon={<LinkedInIcon size={18} />}>
              Connect on LinkedIn
            </Button>
          </div>

          <dl className="hero__stats" aria-label="At a glance">
            {credibility.map(({ value, label }) => (
              <div className="hero__stat" key={label}>
                <dt className="hero__stat-label">{label}</dt>
                <dd className="hero__stat-value">{value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="hero__portrait">
          <ResponsiveImage
            path="/ProfilePic/Sid_Profile.jpg"
            alt={`Portrait of ${basicInfo.name}`}
            className="hero__photo"
            priority
          />
        </div>
      </div>
    </section>
  );
};

export default ProfileIntro;
